<template>
	<v-container>
		<v-row no-gutters>
			<v-col :cols="value.readType != null ? null : 12">
				<!-- COMBO PRODUCTION OR COMSUMPTION PRODS E CONS -->
				<div v-if="value.typeData == 9 && parameter">
					<v-select
						ref="aggregateValueField"
						prepend-icon="mdi-buffer"
						:loading="loadingItems"
						v-model="model.aggregateValue"
						:label="`${value.label} / ${$t('options')}`"
						:items="items"
						item-text="description"
						item-value="id"
						:rules="value.isRequired ? $isRequiredRule : []"
						clearable
						@keyup.enter.native="checkEnter"
					></v-select>
					<v-select
						ref="aggregateValueField"
						prepend-icon="mdi-shape-plus"
						:loading="loadingItems"
						v-model="model.aggregateValues.parameterId"
						:label="value.label"
						:items="parameter"
						item-text="description"
						item-value="id"
						:rules="value.isRequired ? $isRequiredRule : []"
						@keyup.enter.native="checkEnter"
						@input="setParameterInput"
					></v-select>
					<div>
						<v-text-field
							ref="valueField"
							v-model="model.value"
							:label="value.label"
							:type="inputType"
							:rules="value.isRequired ? $isRequiredRule : []"
							@keyup.enter.native="checkEnter"
						/>
					</div>
				</div>

				<div
					v-if="
						value.typeData != 9 &&
							(value.behavior == 2 || value.behavior == 0) &&
							(itemsConsIds.length > 0 || itemsProdIds.length > 0)
					"
				>
					<v-select
						ref="aggregateValueField"
						prepend-icon="mdi-buffer"
						:loading="loadingItems"
						v-model="model.aggregateValue"
						:label="`${value.label} / ${$t('options')}`"
						:items="items"
						item-text="description"
						item-value="id"
						:rules="value.isRequired ? $isRequiredRule : []"
						clearable
						@keyup.enter.native="checkEnter"
					></v-select>
				</div>

				<div
					v-if="
						value.typeData != null &&
							(value.behavior == 2 || value.behavior == 0) &&
							(items.length == 0 || !items)
					"
				>
					<v-select
						prepend-icon="mdi-buffer"
						:label="`${value.label} / ${$t('options')}`"
						item-text="description"
						item-value="id"
						:rules="value.isRequired ? $isRequiredRule : []"
						clearable
						@keyup.enter.native="checkEnter"
					></v-select>
				</div>

				<!-- TAGITEM    -->
				<v-autocomplete
					ref="valueField"
					v-if="value.typeData == 6"
					v-model="model.value"
					:items="tagItem.tags"
					:loading="tagItem.loading"
					:search-input.sync="tagItem.search"
					item-text="value"
					item-value="value"
					color="primary"
					hide-no-data
					hide-selected
					:label="value.label"
					:prepend-icon="tagItem.icon"
					@input="tagItemInput"
					clearable
					return-object
					@keyup.enter.native="checkEnter"
				></v-autocomplete>

				<!-- ATTACH -->
				<div v-if="value.typeData == 5">
					<v-layout>
						<v-file-input
							:label="value.label"
							class="mr-5"
							@change="fileInputChange"
							ref="valueField"
							v-model="file"
							@keyup.enter.native="checkEnter"
						></v-file-input>
						<v-btn fab dark small color="primary" @click="takePicture">
							<v-icon>mdi-camera</v-icon>
						</v-btn>
					</v-layout>

					<img
						v-if="file && ['image/jpeg', 'image/png'].includes(file['type'])"
						:src="fileBase64"
						height="120"
					/>

					<camDialog
						@snapshot="camDialogSnapshot"
						v-model="camDialogOpen"
					></camDialog>
				</div>

				<!-- DRAW -->
				<draw-content
					ref="valueField"
					v-if="value.typeData == 7"
					v-model="model.value"
					:label="value.label"
					:length="value.length"
				></draw-content>

				<!-- TEXT -->
				<div v-if="value.typeData == 0">
					<v-text-field
						ref="valueField"
						v-model="model.value"
						:label="value.label"
						:type="inputType"
						:rules="value.isRequired ? $isRequiredRule : []"
						@keyup.enter.native="checkEnter"
						:autofocus="listaFocus[0]"
					/>
				</div>

				<!-- NUMERIC -->
				<div v-if="value.typeData == 1">
					<v-text-field
						ref="valueField"
						v-model="model.value"
						:label="value.label"
						:type="inputType"
						:rules="value.isRequired ? $isRequiredRule : []"
						@keyup.enter.native="checkEnter"
						:autofocus="listaFocus[1]"
					/>
				</div>

				<!-- BOOLEAN -->
				<div v-if="value.typeData == 2">
					<v-checkbox
						ref="valueField"
						v-model="model.value"
						:label="value.label"
						:rules="value.isRequired ? $isRequiredRule : []"
						@keyup.enter.native="checkEnter"
						:autofocus="listaFocus[2]"
					></v-checkbox>
				</div>

				<!-- COMBO -->
				<div v-if="value.typeData == 3">
					<v-select
						ref="valueField"
						v-model="model.value"
						:label="value.label"
						:items="value.combo"
						:rules="value.isRequired ? $isRequiredRule : []"
						@keyup.enter.native="checkEnter"
					></v-select>
				</div>


				<!-- TIME -->
				<div v-if="value.typeData == 10">
					<v-text-field
						ref="valueField"
						v-model="model.value"
						:label="value.label"
						type="time"
						:rules="value.isRequired ? $isRequiredRule : []"
						:autofocus="listaFocus[3]"
					/>

				</div>

				<!-- VARIABLE -->
				<div v-if="value.typeData == 4">
					<v-layout>
						<v-text-field
							ref="valueField"
							v-model="model.value"
							:label="value.label"
							:type="inputVariableType"
							:readonly="value.readOnly"
							:rules="value.isRequired ? $isRequiredRule : []"
							@keyup.enter.native="checkEnter"
							:autofocus="listaFocus[4]"
						/>
						<v-btn class="mt-2" icon color="primary" @click="getValueVariable">
							<v-icon>mdi-refresh</v-icon>
						</v-btn>
					</v-layout>
				</div>

				<!-- VIDEO -->

				<div v-if="value.typeData == 8">
					<reg-type-field-video-record v-model="model" :regTypeField="value" :autofocus="listaFocus[5]">
					</reg-type-field-video-record>
				</div>

				<!-- BAR CODE-->
			</v-col>
			<v-col cols="1">
				<!-- ReadType -->
				<span :cols="value.readType != null ? 1 : 0">
					<!-- <v-text-field
              ref="valueField"
              v-model="model.value"
              :label="value.label"
              type="text"
              clearable
              :rules="value.isRequired ? $isRequiredRule : []"
              @keyup.enter.native="checkEnter"
          />-->
					<v-btn
						v-if="value.readType != null"
						color="primary"
						class
						small
						fab
						@click="eanScanOpen = true"
						:autofocus="listaFocus[6]"
					>
						<v-icon>mdi-barcode-scan</v-icon>
					</v-btn>
					<ean-scan-dialog
						v-model="eanScanOpen"
						:type="value.readType"
						@scan="(text) => (model.value = text)"
					></ean-scan-dialog>
				</span>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import regTypeFieldVideoRecord from "./regTypeFieldVideoRecord";
	import itemService from "@/services/itemService";
	import inMemoryService from "@/services/inMemoryService.js";
	import camDialog from "@/components/dialogs/camDialog";
	import eanScanDialog from "@/components/barcodes/eanScanDialog";
	import drawContent from "@/components/draws/drawContent";

	export default {
		props: {
			value: {},
			jobStage: {},
			values: {},
			variables: [],
			continuous: {
				default: false,
			},
			// methods: {
			// 	postValueVariable: async function() {
			// 		console.log("kkkdwkdwdw");
			// 		await inMemoryService.postValueVariable(
			// 			this.value.variableKey,
			// 			this.model.value
			// 		);
			// 	},
			// },
		},
		components: {
			camDialog,
			eanScanDialog,
			drawContent,
			regTypeFieldVideoRecord,
			
		},
		data() {
			return {
				items: [],
				parameter: null,
				isValid: true,
				loadingItems: false,
				file: null,
				fileBase64: null,
				camDialogOpen: false,
				eanScanOpen: false,
				tagItem: {
					tags: [],
					loading: false,
					search: "",
					isBusy: false,
					icon: "mdi-tag",
				},
				model: {
					regFieldId: null,
					field: null,
					aggregateValue: null,
					value: null,
					aggregateValues: {},
				},
				listaFocus: []
			};
		},
		watch: {
			async "tagItem.search"(val) {
				if (!val || this.isBusy) return;
				this.loadingItems = true;
				let res = await this.$http.get(`item/s-tag`, {
					value: val,
					itemId: this.model.aggregateValue,
				});

				if (res.success) {
					if (this.value.behavior == 0)
						this.tagItem.tags = [
							{
								value: val,
								new: true,
							},
						];
					res.data.forEach((i) =>
						this.tagItem.tags.push({
							text: i,
							value: i,
						})
					);
				}
				this.loadingItems = false;
			},
			// async file() {
			//   if (this.file) {
			//     this.model.value = await this.$toBase64(this.file);
			//     JSON.stringify(this.file);
			//     this.model.aggregateValue = this.$refs.valueField.text[0];
			//   }
			// },

			async model() {
				this.$emit("input", this.model);
				await this.getValueVariable();
				await this.getItems();
				this.fileBase64 = null;
				this.file = null;
			},
			async value() {
				this.model = this.getModelDefault();
				this.fileBase64 = null;
				this.file = null;

				await this.getValueVariable();
				await this.getItems();
			},
		},

		computed: {
			inputType() {
				return this.value.typeData == 1 ? "number" : "text";
			},

			inputVariableType() {
				return this.value.variableType == 1 ? "number" : "text";
			},
			itemsConsIds() {
				try {
					if (!this.jobStage || this.jobStage.jobStageItemConss.length == 0)
						return [];
					let ids = [];
					this.jobStage.jobStageItemConss.forEach((c) => ids.push(c.itemId));
					return ids;
				} catch (err) {
					return [];
				}
			},

			itemsProdIds() {
				if (
					!this.jobStage ||
					!this.jobStage.jobStageItemProds ||
					this.jobStage.jobStageItemProds.length == 0
				)
					return [];
				let ids = [];
				this.jobStage.jobStageItemProds.forEach((c) => ids.push(c.itemId));
				return ids;
			},
		},

		methods: {
			setParameterInput(itemId) {
				console.log("itemId", itemId);
				if (!itemId) return;
				let behavior = this.value.behavior;
				let items =
					behavior == 0
						? this.jobStage.jobStageItemProds
						: this.jobStage.jobStageItemConss;
				let item = items.find((i) => i.itemId == itemId);
				if (!item) return;
				this.model.value = item.qtEstimated;
			},

			checkEnter() {
				if (this.continuous) {
					this.postValueVariable();
				}
				this.$emit("enter");
			},
			openEanScanDialog() {},
			valueIsNotNull() {
				return this.model.value != null;
			},
			valueIsNull() {
				return !this.model.value;
			},
			aggregateValueIsFocused() {
				if (!this.$refs.aggregateValueField) return false;
				return this.$refs.aggregateValueField.isFocused;
			},
			focus() {
				if (
					this.value.typeData &&
					(this.value.behavior == 2 || this.value.behavior == 0) &&
					(this.itemsConsIds.length > 0 || this.itemsProdIds.length > 0)
				) {
					if (this.$refs.aggregateValueField.isFocused == false)
						this.$refs.aggregateValueField.focus();
					else this.$refs.valueField.focus();
					return;
				}
				this.$refs.valueField.focus();
			},
			tagItemInput(tag) {
				if (!tag) {
					this.tagItem.icon = "mdi-tag";
					return;
				}

				this.model.value = tag.value;

				if (tag.new == true) {
					this.tagItem.icon = "mdi-tag-plus";
					return;
				}

				this.tagItem.icon = "mdi-tag";
			},

			async camDialogSnapshot(file) {
				this.file = file;
				await this.fileInputChange(file);
			},

			takePicture() {
				this.camDialogOpen = true;
			},

			async fileInputChange(file) {
				if (file == null) {
					this.model.value = null;
					this.model.aggregateValue = null;
				} else {
					this.fileBase64 = await this.$toBase64(this.file, true);
					this.model.value = await this.$toBase64(this.file);
					this.model.aggregateValue = this.$refs.valueField.text[0];
					this.$forceUpdate();
				}
			},

			validate() {
				return true;
			},

			async postValueVariable() {
				let variableFilter = this.variables.filter((variable) => variable.variableInternal == this.value.variableKey)
				let variableKey = variableFilter.length > 0 ? variableFilter[0].variableKey : this.value.variableKey

				if (this.value.readType != null) {
					await inMemoryService.postValueVariable(
						this.value.label,
						this.model.value
					);
				} else {
					await inMemoryService.postValueVariable(
						variableKey,
						this.model.value
					);
				}
			},

			async getValueVariable() {
				if (this.value.readType != null) {
					let res = await inMemoryService.getValueVariable(this.value.label);
					if (res.success && res.data) this.model.value = res.data;
					return;
				}
				if (this.value.typeData == 4 || this.value.typeData == 0) {
					let variableFilter = this.variables.filter((variable) => variable.variableInternal == this.value.variableKey)

					let variableKey = variableFilter.length > 0 ? variableFilter[0].variableKey : '' // this.value.variableKey
					console.log("variableFilter >>> ", variableKey)
					let res = await inMemoryService.getValueVariable(
						variableKey
					);
					if (res.success && res.data){
						this.model.value = res.data;
					} else {
						this.model.value = ''
					}
					return;
				}
			},

			getValue() {
				this.createModel();
				return this.model;
			},

			createModel() {
				this.model.regFieldId = this.value.id;
				this.model.field = this.value.label;
				if (this.value.typeData == 2 && this.model.value == "")
					this.model.value = false;
			},

			getModelDefault() {
				let obj = {
					regFieldId: "",
					field: "",
					aggregateValue: "",
					value: "",
				};
				if (this.continuous) {
					obj.value = this.model.value;
					obj.aggregateValue = this.model.aggregateValue;
				}

				return obj;
			},
			clearDraw() {
				if (this.value.typeData == 7) {
					this.$refs.valueField.clear();
				} else {
					return;
				}
			},
			async getItems() {
				if (!(this.value.behavior == 2 || this.value.behavior == 0)) return;
				this.loadingItems = true;
				let res =
					this.value.behavior == 2
						? await itemService.getByIds(this.itemsConsIds)
						: await itemService.getByIds(this.itemsProdIds);
				this.loadingItems = false;

				if (res.success) {
					this.addItemsMaterial(res.data);
					this.addParameter(res.data);
				}

				this.$forceUpdate();
			},
			addItemsMaterial(items) {
				if (!items || items.length == 0) return;

				this.items = items.filter((t) => t.type != "Parameter");

				if (this.items.length == 1)
					this.model.aggregateValue = this.items[0].id;
			},

			addParameter(items) {
				if (this.value.typeData != 9) return;
				let parameter = items?.find((i) => i.id == this.value.parameterItemId);
				if (!parameter) return;
				this.parameter = [parameter];
				this.model.aggregateValues.parameterId = parameter.id;
				this.setParameterInput(parameter.id);
				//this.addItemsMaterial(this.items);
			},

			containerFocus(){
				// VERIFICA SE A CONDIÇÃO DA DIV É VERDADEIRA E RETORNA PARA O ARRAY 
				// PARA ATIVAR O AUTOFOCUS DO VUETIFY
				this.value.typeData == 0 ? this.listaFocus[0] = true : this.listaFocus[0] = false;
				this.value.typeData == 1 ? this.listaFocus[1] = true : this.listaFocus[1] = false;
				this.value.typeData == 2 ? this.listaFocus[2] = true : this.listaFocus[2] = false;
				this.value.typeData == 10 ? this.listaFocus[3] = true : this.listaFocus[3] = false;
				this.value.typeData == 4 ? this.listaFocus[4] = true : this.listaFocus[4] = false;
				this.value.typeData == 8 ? this.listaFocus[5] = true : this.listaFocus[5] = false;
				this.value.readType != null ? this.listaFocus[6] = true : this.listaFocus[6] = false;
				this.corrigirListaFocus();
			},

			async corrigirListaFocus(){
				// COM BASE NA PRIMEIRA ALTERNATIVA VERDADEIRA AS DEMAIS SE TORNAM FALSAS NO CORRIGIRLISTAARRAY
				var cont = 0
				for(var i=0 ; i < 11 ; i++){
					if(cont == 0 && this.listaFocus[i] == true){
						cont = 1
					}else{
						this.listaFocus[i] == false
					}
				}
			}
		},

		async mounted() {
			this.model.regFieldId = this.value.id;
			this.model.field = this.value.label;
			if (this.value.typeData == 2 && this.model.value == "")
				this.model.value = false;

			// Added typeData == 0 - 28-06-2022
			if (this.value.typeData == 4 || this.value.typeData == 0)
				await this.getValueVariable();

			if (this.value.behavior == 2 || this.value.behavior == 0)
				await this.getItems();

			if (this.value.typeData == 3) {
				if (this.value.combo && this.value.combo.length == 1) {
					this.model.value = this.value.combo[0];
				}
			}
		},

		created() {
			this.containerFocus()
			this.$root.$on("clean", () => {
				this.model = this.getModelDefault();
				this.clearDraw();
			});
		},
	};
</script>
